import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const services = [
  { image: 'img/keyword-image/pg-in-pune.jpg', title: 'PG in Pune',para:"Om Sai PG is the perfect solution for students and working professionals looking for a hassle-free and home-like living experience in the heart of Kharadi, near the renowned EON IT Park. With top-notch facilities, spacious rooms, and an ideal location, Om Sai PG ensures that your stay in Pune is both comfortable and memorable." ,link:'/PG-In-Pune'},
  { image: 'img/keyword-image/Pg-near-kharadi-bypass.jpg', title: 'PG Near Kharadi Bypass',para:'haradi Bypass, being a crucial connectivity point near the Kharadi area, is home to numerous professionals and students working and studying in Punes booming IT sector. For those seeking convenience, affordability, and modern amenities, Om Sai PG offers the perfect living solution.' ,link:'/PG-Near-Kharadi-Bypass'},
  { image: 'img/keyword-image/Hostels-in-kharadi.jpg', title: 'Hostels in Kharadi', para:'Om Sai PG Hostel offers comfortable and affordable accommodations for both males and females in the heart of Kharadi, Pune. Located in a prime location, Om Sai PG is ideal for professionals, students, and individuals looking for a secure, convenient, and homely environment.', link:'/Hostels-in-Kharadi'},
  { image: 'img/keyword-image/pg-for-student-in-kharadi.jpg', title: 'PG for Students in Kharadi Pune' ,link:'/PG-for-Students-in-Kharadi-Pune',para:'If youre looking for a PG for students in Kharadi, Pune, Om Sai PG offers the perfect solution. Kharadi is not just an emerging commercial hub but also home to various educational institutions. For students attending college or university in Pune, Om Sai PG is the ideal place to stay, offering comfort, affordability, and a range of modern amenities designed to make student life easier.'},
  { image: 'img/keyword-image/pg-near-Eon-IT-park.jpg', title: 'PG Near Kharadi Eon IT Park',link:'/PG-Near-Kharadi-Eon-IT-Park',para:'Kharadi, with its vibrant IT hub and excellent infrastructure, is home to numerous professionals and students working in the IT sector. Finding the right PG accommodation in this area can be crucial for both comfort and convenience.Om Sai PG offers one of the best living experiences for those looking for a PG near EON IT Park. Our well-equipped, affordable, and comfortable paying guest rooms are designed to cater to the needs of professionals and students working and studying in the Kharadi area.'},
  { image: 'img/keyword-image/pg-in-kharad-with-food.jpg', title: 'PG in Kharadi With Food' ,para:'Look no further than Om Sai PG, ideally located near Eon IT Park in Kharadi, Pune. Whether you’re a student or a professional, Om Sai PG offers a perfect living space with delicious meals included, making it an excellent choice for those seeking a hassle-free stay in this thriving area.Kharadi is one of Punes most sought-after locations, known for its proximity to Eon IT Park, educational institutions, and shopping hubs. ' ,link:'/PG-in-Kharadi-With-Food'},
  { image: 'img/keyword-image/pg-for-working-professionals.jpg', title: 'PG for Working Professionals Pune',para:'Finding a PG for working professionals in Pune can be a challenge, but Om Sai PG offers the ideal solution. With its strategic location in Kharadi, close to major IT parks, business hubs, and transport links, Om Sai PG provides a comfortable, convenient, and affordable living experience for working professionals.Whether you are new to Pune or just looking for a more convenient living arrangement, Om Sai PG offers the perfect blend of privacy, amenities, and affordability. Read on to learn why Om Sai PG is the best choice for working professionals.',link:'/PG-for-Working-Professionals-Pune' },
  { image: 'img/keyword-image/best-luxury-pg-in-pune.jpg', title: 'Best Luxury PG in Pune',para:'Look no further than Om Sai PG. Located in the prime area of Kharadi, Pune, near EON IT Park, Om Sai PG offers an exceptional PG accommodation experience with luxurious facilities, tailored to meet the needs of working professionals, corporate employees, and students.With state-of-the-art amenities, modern interiors, and premium services, Om Sai PG ensures a stay that feels just like home, but with the added benefit of 5-star comfort and security. Read on to learn more about why Om Sai PG is considered one of the best luxury PGs in Pune.',link:'/Best-Luxury-PG-in-Pune' },
  { image: 'img/keyword-image/pg-in-kharadi-for-male.jpg', title: 'Boys Hostels in Kharadi',para:'Om Sai Boys Hostel offers comfortable, affordable, and secure accommodation for students and working professionals. Situated in the prime location of Kharadi, Pune, our hostel provides all the necessary amenities for a hassle-free living experience. Whether youre looking for a place near your office or your college, Om Sai Boys Hostel offers a perfect blend of comfort, security, and convenience.',link:'/Boys-Hostel-in-Kharadi' },
];

export default function Service() {
  return (
    <>

<Helmet>
 
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in",
      "logo": "https://www.omsaipg.in/logo.jpg",
      "image":"https://www.omsaipg.in/ogimage.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipg@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 8,500-6000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "telephone": "+91 9763888448",
     "email":"omsaipgpune@gmail.com",
      "keywords": [
        "PG in Pune",
        "PG in Kharadi",
        "PG with food in Pune",
        "PG for students in Kharadi",
        "PG for females in Pune",
        "PG for males in Pune",
        "Om Sai PG Kharadi",
        "Girls Hostels in Kharadi",
        "Boys Hostel in Kharadi",
        "Monthly Basis PG in Kharadi",
        "PG in Wagholi",
        "PG in Kharadi with food",
        "Hostels in Pune",
        "PG for Students in Kharadi Pune",
        "Paying Guest Hostel in Chandan Nagar"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>
    Contact : +91 9763888448 / +91 9922248255 | Om Sai PG |Service|Best PG Accommodation in Pune, Kharadi | Paying Guest in Kharadi | Om Sai PG Kharadi | Paying Guest in Kharadi | PG in Kharadi for male
  </title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
  />
  <meta
    name="keywords"
    content="PG in Pune, PG in Kharadi, PG with food in Pune, PG for students in Kharadi, PG for females in Pune, PG for males in Pune, Om Sai PG Kharadi, Girls Hostels in Kharadi, Boys Hostel in Kharadi, Monthly Basis PG in Kharadi, PG in Wagholi, PG in Kharadi with food, Hostels in Pune, PG for Students in Kharadi Pune, Paying Guest Hostel in Chandan Nagar"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
  />
  <meta
    property="og:description"
    content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
  />
  <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in" />
  <meta property="og:type" content="website" />
</Helmet>

<section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img2">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>Service</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>Service</h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li>Service</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


      <section className="om-sai-pg-services">
        <div className="container">
          <h2 className="section-title text-purple"> <span className=''>Services At</span> Om Sai PG</h2>
          <p className="intro-text">
            At Om Sai PG, we take pride in offering exceptional services designed to elevate your living experience and ensure utmost convenience throughout your stay.
          </p>

          <div className="services-list">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <img src={service.image} alt={service.title} className="service-image" />
                <h3>{service.title}</h3>
                <p>{service.para}</p>
                <button className="check-services-btn"><Link to={service.link}>Read More...</Link></button>
              </div>
            ))}
          </div>

          {/* <div className="contact-us">
            <p><strong>Contact Us</strong></p>
            <button className="contact-us-btn">Get in Touch</button>
          </div> */}
        </div>
      </section>
    </>
  );
}
